
import { AutoRule } from "@/lib/model/exambuilder/auto-rule";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class CopyExamAutoRulePage extends Vue {
  @Prop({}) configData!: {};
  formData: any;
  rules = {
    targetExamVersionIds: [
      { required: true, message: "请输入目标面试批次列表", trigger: "change" },
      {
        validator: (rule: any, value: any, callback: any) => {
          const regex = /^(\d+|\s*)$/gm; // 正则表达式：只允许数字和换行
          if (!regex.test(value)) {
            callback(new Error("目标面试批次列表只能包含数字"));
          } else {
            callback(); // 验证通过
          }
        },
        trigger: "change"
      }
    ]
  };

  created() {
    this.formData = this.configData;
  }

  editCancel() {
    this.$emit("close", false);
  }
  editOk() {
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        const submitData = this.convertFormData();
        AutoRule.copy(submitData).then((res: any) => {
          if (res.data.code === 0) {
            this.$message.success(
              "异步任务提交成功，请在飞书“AI面试后台异步任务通知群”中查看结果"
            );
            this.$emit("ok");
          } else {
            this.$message.error(res.data.message || "出现错误");
          }
        });
      } else {
        //
      }
    });
  }

  convertFormData() {
    return {
      fromExamVersionId: this.formData.fromExamVersionId,
      targetExamVersionIdList: this.formData.targetExamVersionIds
        .split("\n")
        .filter(Boolean)
        .map((id: string) => Number(id.trim()))
    };
  }
}
